import { toLocaleString } from "@circle-react/helpers/number";
import { Typography } from "@circle-react-uikit/Typography";
import { ChartContainer } from "../shared/ChartContainer";
import { LoadingChartComponent } from "../shared/LoadingChartComponent";

interface OverviewStatComponentProps {
  className?: string;
  isLoading?: boolean;
  prefix?: string;
  suffix?: string;
  title: string;
  tooltip?: string;
  value: number;
}

export const OverviewStatComponent = ({
  prefix,
  suffix,
  title,
  tooltip,
  value,
  isLoading,
  className,
}: OverviewStatComponentProps) => {
  if (isLoading) {
    return <LoadingChartComponent type="stat" className={className} />;
  }

  const localValue = toLocaleString(value);

  return (
    <ChartContainer title={title} tooltip={tooltip} className={className}>
      <Typography.TitleXxl
        as="div"
        weight="font-extrabold"
        color="text-very-dark"
      >
        {prefix}
        {localValue}
        {suffix}
      </Typography.TitleXxl>
    </ChartContainer>
  );
};
